import { render, staticRenderFns } from "./TeamData.vue?vue&type=template&id=3ebf4884"
import script from "./TeamData.vue?vue&type=script&lang=js"
export * from "./TeamData.vue?vue&type=script&lang=js"
import style0 from "./TeamData.vue?vue&type=style&index=0&id=3ebf4884&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports